import { Globe2 } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

const Markets = () => {
  const { t } = useLang();

  return (
    <section id="markets" data-testid="markets-section" className="section-pad bg-[#0E5A4E] text-white relative overflow-hidden">
      {/* Decorative globe gradient */}
      <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-[#D4AF37]/10 blur-3xl" />
      <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-white/5 blur-3xl" />

      <div className="container-cust relative">
        <div className="max-w-3xl mb-16">
          <p className="eyebrow mb-5 text-[#D4AF37]">
            <span className="eyebrow-line bg-[#D4AF37]"></span>
            {t.markets.eyebrow}
          </p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
            {t.markets.title}
          </h2>
          <p className="mt-6 text-white/75 text-base md:text-lg max-w-2xl">
            {t.markets.subtitle}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10">
          {t.markets.regions.map((r, i) => (
            <div
              key={i}
              data-testid={`market-${i}`}
              className="bg-[#0E5A4E] p-8 lg:p-10 group hover:bg-[#0B4A40] transition-colors"
            >
              <Globe2 className="w-5 h-5 text-[#D4AF37] mb-6" />
              <h3 className="font-serif-display text-xl lg:text-2xl text-white mb-3">
                {r.name}
              </h3>
              <p className="text-sm text-white/70 leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Markets;
